import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';

interface ProtectedRouteProps {
  children: React.ReactNode;
  /** Require the admin role. Non-admins are sent back to /app. */
  adminOnly?: boolean;
}

export default function ProtectedRoute({ children, adminOnly = false }: ProtectedRouteProps) {
  const { isAuthenticated, user } = useAuthStore();
  const hasToken = localStorage.getItem('token');

  if (!isAuthenticated && !hasToken) {
    return <Navigate to="/login" replace />;
  }

  if (adminOnly) {
    // user is hydrated asynchronously via checkAuth(); until it arrives we
    // can't know the role, so render nothing rather than flashing the page.
    if (!user) return null;
    if (user.role !== 'admin') return <Navigate to="/app" replace />;
  }

  return <>{children}</>;
}
